module.exports = __webpack_public_path__ + "6966b3df70541b83b18b86dcb0141e33.svg";